import { Stack } from "expo-router";
import { useTheme } from "@/hooks/useTheme";
import Head from "expo-router/head";

export default function ClockinLayout() {
  const { colors } = useTheme();

  return (
    <>
      <Head>
        <title>RockForce Kiosk</title>
        <meta name="description" content="" />
      </Head>
      <Stack
        screenOptions={{
          animation: "simple_push",
          headerShown: false,
          contentStyle: { backgroundColor: colors.background },
        }}
      >
        <Stack.Screen name="invite" />
        <Stack.Screen name="[shift]" />
      </Stack>
    </>
  );
}
